import React, { useEffect, useState } from "react"
import { enumUtil } from "../../../../utils/Enum"
import NotificationHandler from "../../../../utils/NotificationHandler"
import FormValidator from "../../../../utils/FormValidator"
import isNull from "../../../../utils/NullChecking"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import Loader from "../../../shared/Loader/Loader"
import { MenuItem, Select } from "@mui/material"
import DeleteConfirmatiom from "../../../General/DeleteConfirmation"
import Modal from 'react-bootstrap/Modal';
import Audit from "../../../General/Audit"
import ModalHeader from "../../Shared/ModalHeader"
import ModalFooter from "../../Shared/ModalFooter"
import { useSelector } from "react-redux"
import { FindSecondChild } from "../../../../utils/FindMenuOption"
const AddNewInsuranceCategory = (props) => {
    let IsEditAllowed = FindSecondChild('Setup', 'Insurance', 'Insurance Category')?.IsAdd
    let IsDeleteAllowed = FindSecondChild('Setup', 'Insurance', 'Insurance Category')?.IsDeleted
    const API_URL = enumUtil.controller.General
    const { IsOpenInsuranceCategory, onClose, onDeleteInuranceC, type } = { ...props }
    const [del, setDel] = useState(false)
    const [isOpenAudit, setisOpenAudit] = useState(false);
    let InsuranceCategory_Modal = {
        CategoryName: "",
        Description: "",
        UpdatedDate: "",
        UpdatedBy: ""

    }

    let valModal = {}
    // validation modal 
    let ValidationModal = {
        CategoryName: "",
        Description: "",

    }
    const [mainInsuranceCategoryModal, setmainInsuranceCategoryModal] = useState(InsuranceCategory_Modal);
    const [InsuranceCategorySaveUpdateModal, setInsuranceCategorySaveUpdateModal] = useState({})
    const [practiceValidationModal, setPracticeValidationModal] = useState(ValidationModal)
    const [InsuranceCategoryID, setInsuranceCategoryID] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const [onInsuranceCSave, setOnInsuranceCSave] = useState(false)
    // find practice Data by id 
    useEffect(() => {

        if (props.InsuranceCategoryID != null) {
            setInsuranceCategoryID(props.InsuranceCategoryID)
            setDel(true)
        } else {
            if (!onInsuranceCSave) {
                setInsuranceCategoryID(0);
                setDel(false)
            } else {
                setDel(true)
            }

        }
        if (!isNull(InsuranceCategoryID)) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": InsuranceCategoryID,
                "TableName": enumUtil.enumAPITableName.InsurranceCategory
            }).then((response) => {
                setIsLoading(false)
                setmainInsuranceCategoryModal(response)
                // setInsuranceID(response.InsuranceID)
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            })
        }
    }, [InsuranceCategoryID])


    // handle change for Practice 
    const handleInsuranceCategoryChange = (e) => {
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainInsuranceCategoryModal };
        let saveModal = { ...InsuranceCategorySaveUpdateModal }
        modal[name] = value
        setmainInsuranceCategoryModal(modal)
        for (var property in InsuranceCategory_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setInsuranceCategorySaveUpdateModal(saveModal)
    }

    const PracticeValidation = async () => {
        let ValidationModal = {
            PracticeCodeVal: FormValidator(
                mainInsuranceCategoryModal.CategoryName,
                enumUtil.enumValidationType.Required,
                'Category Name',
            ),
            // PracticeCodeVals: FormValidator(
            //     mainInsuranceCategoryModal.Description,
            //     enumUtil.enumValidationType.Required,
            //     'Description ',
            // )
        }
        await setPracticeValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    // save practice button click 
    const handleSaveInsuranceCategory = async () => {
        await PracticeValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            let saveModal = {
                TableName: enumUtil.enumAPITableName.InsurranceCategory,
                ID: InsuranceCategoryID,
                data: { ...InsuranceCategorySaveUpdateModal },
                value: null
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    setIsLoading(false)
                    if (!isNull(response.id)) {
                        NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                        setInsuranceCategoryID(response.id)
                        setOnInsuranceCSave(true)
                        onDeleteInuranceC()
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }


    const handleDeleteModal = () => {
        setisOpenAlert(true)
    }
    let DeletePopup = ""
    if (del) {
        DeletePopup = <button className= {IsDeleteAllowed === false ? 'btn-icon-transparent delete-btn-disabled' : 'btn-icon-transparent '} onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
    }
    const onCloseDelete = () => {
        setisOpenAlert(false)
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} TableName={enumUtil.enumAPITableName.InsurranceCategory} ID={InsuranceCategoryID} onClose={onDeleteInuranceC} API_URL={API_URL} />
    }
    const SetInsuranceName = () => {
        if (mainInsuranceCategoryModal.CategoryName) {
            return (
                <p className="heading">{mainInsuranceCategoryModal.CategoryName}</p>
            )
        } else {
            return (
                <p className="heading">Add New Insurance Category</p>
            )
        }
    }

    const handleAuditModal = () => {
        setisOpenAudit(true)
    }
    const onCloseAudit = () => {
        setisOpenAudit(false)
    }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={InsuranceCategoryID + ""} TableName={enumUtil.enumAPITableName.InsurranceCategory} />
    }
    const AddNewInsuranceCategoryModalBody = () => {
        return (
            <div>
                <div className="form-group input">
                    <label htmlFor="CategoryName">Category Name<span className='req'>*</span></label>
                    <div className={practiceValidationModal.PracticeCodeVal ? 'form-group input error' : 'form-group input'}>
                        <input type="text"
                            className='form-control'
                            required
                            name="CategoryName"
                            id="CategoryName"
                            autoComplete="off"
                            maxLength={12}
                            value={mainInsuranceCategoryModal.CategoryName}
                            onChange={handleInsuranceCategoryChange}
                        />
                        {practiceValidationModal.PracticeCodeVal}
                    </div>
                    {/* error helperText="Error Message" */}
                </div>
                <div className='form-group input'>
                    <label htmlFor="Description">Description</label>
                    <textarea type="text"
                        rows='10'
                        className='form-control'
                        name="Description"
                        id="Description"
                        value={mainInsuranceCategoryModal.Description}
                        onChange={handleInsuranceCategoryChange}
                    />
                </div>

            </div>
        )
    }
    return (
        <React.Fragment>
            {DeleteConfirmation}
            {type && type === "Wizard" ?
                <div>
                    {AuditPopup}
                    {isLoading ? <Loader /> : null}
                    {AddNewInsuranceCategoryModalBody()}
                    <ModalFooter isSaved={onInsuranceCSave ? onDeleteInuranceC : onClose} handleSave={handleSaveInsuranceCategory} UpdatedDate={mainInsuranceCategoryModal.UpdatedDate} UpdatedBy={mainInsuranceCategoryModal.UpdatedBy} ID={InsuranceCategoryID} IsEditAllowed={IsEditAllowed} />
                </div>
                :
                <Modal show={IsOpenInsuranceCategory} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 ar-small-modal">
                    {AuditPopup}
                    <Modal.Body>
                        <ModalHeader HeaderName={SetInsuranceName} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} DeletePopup={DeletePopup} isClosed={onInsuranceCSave ? onDeleteInuranceC : onClose} key={623} Name={'Insurrance Category'} />
                        {isLoading ? <Loader /> : null}
                        {AddNewInsuranceCategoryModalBody()}
                    </Modal.Body>
                    <ModalFooter isSaved={onInsuranceCSave ? onDeleteInuranceC : onClose} handleSave={handleSaveInsuranceCategory} UpdatedDate={mainInsuranceCategoryModal.UpdatedDate} UpdatedBy={mainInsuranceCategoryModal.UpdatedBy} ID={InsuranceCategoryID} IsEditAllowed={IsEditAllowed} />
                </Modal>}
        </React.Fragment>

    )
}

export default AddNewInsuranceCategory